import { ChangeDetectorRef, Component, effect, inject, OnInit, input, output } from '@angular/core';

// Services
import { ViewStateService } from '../../../core/_services/view-state/view-state.service';

// Models
import { ViewState } from '../../../core/_models/view-state.model';

@Component({
  selector: 'pp-profile-picture',
  templateUrl: './profile-picture.component.html',
})
export class ProfilePictureComponent implements OnInit {

  readonly alt = input.required<string>();
  readonly id = input.required<string>();
  readonly size = input.required<number>();

  readonly profilePictureExists = output<boolean>();

  cacheBuster?: number;
  viewState?: ViewState | null;

  private readonly cdr = inject(ChangeDetectorRef);
  private readonly viewStateService = inject(ViewStateService);

  private readonly _viewStateEffect = effect(() => {
    const response = this.viewStateService.viewState();
    this.viewState = response;
    this.profilePictureExists.emit(!!response?.profilePictureUri);
    this.cacheBuster = new Date().getTime();
    this.cdr.markForCheck();
  });

  ngOnInit(): void {
    this.profilePictureExists.emit(!!this.viewState?.profilePictureUri);
  }
}
